import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  mostEngaged: {
    key: `ContextList-mostEngaged`,
    defaultValue: `Mais engajados`,
  },
  happeningNow: {
    key: `ContextList-happeningNow`,
    defaultValue: `Acontecendo agora`,
  },
  products: {
    key: `ContextList-products`,
    defaultValue: `Produtos`,
  },
  campaingsAdvertising: {
    key: `ContextList-campaingsAdvertising`,
    defaultValue: `Campanhas e publicidade`,
  },
  events: {
    key: `ContextList-events`,
    defaultValue: `Eventos e datas comemorativas`,
  },
  socialIssues: {
    key: `ContextList-socialIssues`,
    defaultValue: `Questões sociais`,
  },
  yourMostEngagedContent: {
    key: `ContextList-yourMostEngagedContent`,
    defaultValue: `Seus conteúdos mais engajados`,
  },
})
